<template>
  <grid-row v-if="sharedAssets.length" class="mt-100">
    <grid-column :size="4" v-for="(sharedAsset, index) in sharedAssets" :key="index">
      <store-asset-box
        @installed="$emit('installed', $event)"
        :shared-asset="sharedAsset"
        :setting-tab="settingTab"
      ></store-asset-box>
    </grid-column>
  </grid-row>

  <div class="shared_assets--empty" v-else>
    <p class="shared_assets--empty--message">There are no store items yet</p>
  </div>
</template>

<script>
import StoreAssetBox from "./StoreAssetBox";
export default {
  name: "StoreAssetGrid",
  components: {StoreAssetBox},
  props: ['sharedAssets', 'settingTab']
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.asset_grid {
  display: flex;
  flex-wrap: wrap;

  &--box {
    width: 33%;
  }
}

.shared_assets--empty {
  padding: 7rem 0;
  text-align: center;

  &--message {
    font-size: 1.25rem;
    font-style: italic;
    color: $text-muted;
  }
}
</style>
